// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"InfiniteScroll_wrapper__16XKZ","infinite-scroll":"InfiniteScroll_infinite-scroll__3x4_k"};